"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandState = exports.BrandProvider = exports.BrandContext = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var brand_config_1 = require("../../configs/brand.config");
var services_1 = require("../../services");
var enums_1 = require("../../shared/enums");
/**
 * getBrandState
 * @description gets the current brand from the env var
 * @returns a brand state
 */
var getBrandState = function (brandParam) {
    var _a, _b;
    var brandRaw = ((_b = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_BRAND) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || enums_1.BrandEnum.MONARCH;
    var brand = brandParam || enums_1.BrandEnum[brandRaw];
    return {
        brand: brand,
        brandService: new services_1.BrandService(brand),
    };
};
exports.getBrandState = getBrandState;
// create brand context
var BrandContext = react_1.default.createContext(null);
exports.BrandContext = BrandContext;
// setup context provider wrapper
var BrandProvider = function (props) {
    var _a;
    var state = (_a = props.state) !== null && _a !== void 0 ? _a : getBrandState();
    return (react_1.default.createElement(BrandContext.Provider, { value: state },
        react_1.default.createElement(material_1.ThemeProvider, { theme: brand_config_1.brandConfig[state.brand].theme }, props.children)));
};
exports.BrandProvider = BrandProvider;
